import { administratorsRepository } from '@/repositories/administrators.repository';
import { useUserStore } from '@/stores/user';
import { ORG_TYPE } from '@/vos/organizations/meta';
import type { Profile } from '@amministro-io-packages/auth-interfaces';
import type { RouteLocationNormalized as Route } from 'vue-router';

export async function checkOrganizationType(to: Route, _from: Route, next: any) {
  const { profiles } = useUserStore();
  const profile = (profiles as Profile[]).find((pr) => pr.profile_id === to.params.idElement);

  if (!profile) {
    next({ path: '/' });
  }
  else {
    const { data: organization } = await administratorsRepository.getOrganization(profile, profile.company_id);

    if (organization.orgType !== ORG_TYPE.COMPANY) {
      next();
    }
    else {
      next({ path: '/' });
    }
  }
}
